import React from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function PageHero({
  eyebrow,
  title,
  highlight,
  subtitle,
  breadcrumb,
  children,
}) {
  return (
    <section
      data-testid="page-hero"
      className="relative pt-16 pb-20 sm:pt-20 sm:pb-28 border-b border-gray-100 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {breadcrumb && (
          <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#000000]/50 mb-10">
            <Link to="/" className="hover:text-[#000000]">
              Home
            </Link>
            <ChevronRight size={12} />
            <span>{breadcrumb}</span>
          </div>
        )}
        {eyebrow && (
          <p className="eyebrow flex items-center gap-3 mb-5">
            <span className="w-1.5 h-1.5 bg-[#4285F4]" />
            <span className="w-1.5 h-1.5 bg-[#EA4335]" />
            <span className="w-1.5 h-1.5 bg-[#FBBC05]" />
            <span className="w-1.5 h-1.5 bg-[#34A853]" />
            <span>{eyebrow}</span>
          </p>
        )}
        <h1 className="font-display text-3xl sm:text-5xl lg:text-7xl font-bold tracking-tighter text-[#000000] max-w-5xl leading-[1.05]">
          {title}{" "}
          {highlight && (
            <span className="g-underline">{highlight}</span>
          )}
        </h1>
        {subtitle && (
          <p className="mt-8 text-base sm:text-lg lg:text-xl text-[#000000]/70 max-w-3xl leading-relaxed">
            {subtitle}
          </p>
        )}
        {children && <div className="mt-10">{children}</div>}
      </div>
    </section>
  );
}
